var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5","key":0}),React.createElement("rect",{"x":"2","y":"6","width":"14","height":"12","rx":"2","key":1})]);
}

Video.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-video-icon lucide-video"};

module.exports = Video;

Video.default = Video;
